export const START_LOAD_CHECK = 'carValues/START_LOAD';
export const FINISH_LOAD_CHECK = 'carValues/FINISH_LOAD';

const initialState = {
    loading:false,
    check:false
};
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case START_LOAD_CHECK:  return {...state, loading:true};
        case FINISH_LOAD_CHECK:  return {...state, loading:false, check:action.payload};
        default: return state;
    }
}
